import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useLang } from "@/lib/i18n";
import { toast } from "sonner";
import { Award, MapPin, UserSearch } from "lucide-react";

export default function Employer() {
  const [cands, setCands] = useState(null);
  const { pick } = useLang();
  useEffect(() => { api.get("/employer/candidates").then((r) => setCands(r.data)).catch(() => setCands([])); }, []);
  if (!cands) return <p className="text-slate-500">Loading…</p>;

  return (
    <div className="space-y-4">
      <div>
        <h1 className="font-heading text-2xl sm:text-3xl font-extrabold text-slate-900">Talent — Certified Candidates</h1>
        <p className="text-sm text-slate-500">FSCD-certified candidates who opted into employment opportunities. Personal contact details are protected.</p>
      </div>
      {cands.length === 0 && <p data-testid="no-candidates" className="text-slate-400 bg-white rounded-2xl border border-slate-200 p-6 text-center">No certified candidates yet</p>}
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {cands.map((c, i) => (
          <div key={i} data-testid={`candidate-card-${i}`} className="bg-white rounded-2xl border border-slate-200 p-5 space-y-3">
            <div className="flex items-center justify-between">
              <span className="w-11 h-11 rounded-full bg-slate-900 text-white flex items-center justify-center font-heading font-bold">{c.name?.[0]}</span>
              <span className="text-xs font-bold text-white bg-teal-700 px-3 py-1.5 rounded-full">{c.readiness}% ready</span>
            </div>
            <div>
              <p className="font-heading font-bold text-slate-900">{c.name}</p>
              <p className="text-sm text-slate-500">{pick(c.track_title)}</p>
            </div>
            <div className="text-xs text-slate-500 space-y-1">
              <p className="flex items-center gap-1.5"><Award size={13} className="text-amber-500" /> {c.certificate_id}</p>
              <p className="flex items-center gap-1.5"><MapPin size={13} /> {c.city || "India"} {c.preference ? `· prefers ${c.preference}` : ""}</p>
            </div>
            <div className="flex gap-2 pt-1">
              <button data-testid={`view-candidate-${i}`} onClick={() => window.open(`/verify/${c.certificate_id}`, "_blank")}
                className="flex-1 h-10 rounded-xl border border-slate-300 text-slate-700 text-sm font-semibold flex items-center justify-center gap-1"><UserSearch size={15} /> Verify</button>
              <button data-testid={`invite-candidate-${i}`} onClick={() => toast.success(`Interview invitation sent to ${c.name} (demo)`)}
                className="flex-1 h-10 rounded-xl bg-slate-900 text-white text-sm font-semibold">Invite to Interview</button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
